module.exports = __webpack_public_path__ + "img/chevron-right.b80e27e8.svg";